import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './NotFound.css';

export default function NotFound() {
  return (
    <>
      <SEO title="404 — Page Not Found" description="The page you're looking for doesn't exist." canonical="/404" noIndex={true} />
      <Header />
      <div className="nf-page">
        <div className="nf-inner">
          <div className="nf-icon">🔍</div>
          <div className="nf-code">404</div>
          <h1 className="nf-title">Page Not Found</h1>
          <p className="nf-sub">The page you're looking for doesn't exist or has been moved.</p>
          <div className="nf-actions">
            <Link to="/" className="btn-navy">← Back to Home</Link>
            <Link to="/contact" className="btn-outline-navy">Contact Us</Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
